var t = /* @__PURE__ */ ((T) => (T.BOTTOM = "bottom", T.LEFT = "left", T.RIGHT = "right", T.TOP = "top", T))(t || {});
export {
  t as RocheUIDrawerDirection
};
